const cartInstructions = document.querySelector(".cart-instructions");
const coll = document.querySelector(".form-field-header");
if(!cartInstructions || !coll) return;
const textarea = document.querySelector(".collapsible-comment-field");
const span = coll.querySelector("span");
if(!textarea || !span) return;

coll.addEventListener("click", function () {
  textarea.classList.toggle("hidden");
  cartInstructions.classList.toggle("cart-instructions-active-border");
  span.textContent = textarea.classList.contains("hidden") ? " + " : " - ";
});